module.exports = __webpack_public_path__ + "static/media/Storage.e39cf750.svg";